import { apiBaseUrl, apimSubscriptionKey } from "@/constants/index"
import {
  findAStoreUrl,
  getDetailsClient,
  getLocationFromIPURL,
  getStoresServer,
} from "@/utils/constants"
import { aemAxiosInstance, apim } from "@/constants/api"
import { getStateWithCitiesServer } from "./constants"

export const getStateAndCities = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.get(
        `${apiBaseUrl}${findAStoreUrl}/states-with-cities`
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getStoresList = async (
  storeState,
  storeCity,
  isServiceLocator
) => {
  return new Promise(async (resolve, reject) => {
    try {
      let pathUrl = ""
      if (isServiceLocator) {
        pathUrl = `${apiBaseUrl}${findAStoreUrl}?brand=india&state=${storeState}&page=1&limit=100`
      } else {
        pathUrl = `${apiBaseUrl}${findAStoreUrl}?brand=india&state=${storeState}&city=${storeCity}&page=1&limit=100`
      }
      const { data: content } = await apim.get(pathUrl)
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getDetailsFromZipCode = async zipcode => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.get(
        `${apiBaseUrl}${getDetailsClient}?pincode=${zipcode}`
      )
      resolve(content)
    } catch (error) {
      resolve(error.response?.status)
    }
  })
}

export const getDetailsFromPincode = async zipcode => {
  return new Promise(async (resolve, reject) => {
    try {
      aemAxiosInstance.defaults.headers.common[
        "Ocp-Apim-Subscription-Key"
      ] = `${apimSubscriptionKey}`
      const { data: content } = await aemAxiosInstance({
        url: `${apiBaseUrl}${getDetailsClient}?pincode=${zipcode}`,
      })
      resolve(content)
    } catch (error) {
      resolve(error.response.status)
    }
  })
}

export const getStoresFromDetails = async (storeState, storeCity) => {
  return new Promise(async (resolve, reject) => {
    try {
      aemAxiosInstance.defaults.headers.common[
        "Ocp-Apim-Subscription-Key"
      ] = `${apimSubscriptionKey}`
      const { data: content } = await aemAxiosInstance({
        url: `${apiBaseUrl}${getStoresServer}?brand=india&state=${storeState}&city=${storeCity}&page=1&limit=100`,
      })
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getStatesAndCitiesFromServer = async isServiceLocator => {
  return new Promise(async (resolve, reject) => {
    try {
      aemAxiosInstance.defaults.headers.common[
        "Ocp-Apim-Subscription-Key"
      ] = `${apimSubscriptionKey}`
      let pathUrl = ""
      if (isServiceLocator) {
        pathUrl = `${getStateWithCitiesServer}?serviceStoreFlag=true`
      } else {
        pathUrl = `${getStateWithCitiesServer}`
      }
      const { data: content } = await aemAxiosInstance({
        url: `${apiBaseUrl}${pathUrl}`,
      })
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getLocationFromIP = async ip => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.get(
        `${apiBaseUrl}${getLocationFromIPURL}/${ip}`
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}
export const getDealerNames = async (limit = "") => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: content } = await apim.get(
        `${apiBaseUrl}${findAStoreUrl}?brand=india&limit=${limit}`
      )
      resolve(content)
    } catch (error) {
      reject(error)
    }
  })
}

export const getCookieValue = name =>
  document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)")?.pop() || ""

export const reverseGeo = async (lat, long) => {
  try {
    const location = { lat: null, long: null }

    if (!lat) {
      const userCookie = getCookieValue("userLocation")
      const userLocation = userCookie?.split("+")
      if (userLocation.length) {
        location.lat = userLocation[4]
        location.long = userLocation[5]
      }
    }
    const res = await apim.get("/maps/geocoding/reverse", {
      params: {
        $format: "json",
        brand: "india",
        lat: lat ?? location.lat,
        long: long ?? location.long,
      },
    })

    return res.data?.resourceSets[0]?.resources[0]?.address?.postalCode || false
  } catch (ex) {
    console.log("Failed to fetch pincode using lat long", ex)
  }
}
